import { render, staticRenderFns } from "./mobileCode.vue?vue&type=template&id=4c6cd03f"
import script from "./mobileCode.vue?vue&type=script&lang=js"
export * from "./mobileCode.vue?vue&type=script&lang=js"
import style0 from "./mobileCode.vue?vue&type=style&index=0&id=4c6cd03f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports